import { InjectionToken } from '@angular/core';
import { IProjectDataService } from './interfaces/project-data.service';
import { IUpdateService } from './interfaces/update.service';
import { IMaterialDataService } from './interfaces/material-data.service';
import { ICategoryDataService } from './interfaces/category-data.service';
import { IFileIOService } from './interfaces/file-io.service';
import { IAuthService } from './interfaces/auth.service';
import { IUserSettingsService } from './interfaces/user-settings.service';
import { IAssemblyLoaderService } from './interfaces/assembly-loader.service';
import { IOptimizationService } from './interfaces/optimization.service';
import { IChatService } from './interfaces/chat.service';
import { ITabManager } from './interfaces/tab-manager.service';
import { IProjectExportImportService } from './interfaces/project-export-import.service';
import { BdfService } from './interfaces/bdf.service.interface';
import { SoftjawsService } from './interfaces/softjaws.service.interface';

export const PROJECT_DATA_SERVICE = new InjectionToken<IProjectDataService>('ProjectDataService');
export const MATERIAL_DATA_SERVICE = new InjectionToken<IMaterialDataService>('MaterialDataService');
export const CATEGORY_DATA_SERVICE = new InjectionToken<ICategoryDataService>('CategoryDataService');
export const FILE_IO_SERVICE = new InjectionToken<IFileIOService>('FileIOService');
export const AUTH_SERVICE = new InjectionToken<IAuthService>('AuthService');
export const USER_SETTINGS_SERVICE = new InjectionToken<IUserSettingsService>('UserSettingsService');
export const ASSEMBLY_LOADER_SERVICE = new InjectionToken<IAssemblyLoaderService>('AssemblyLoaderService');
export const OPTIMIZATION_SERVICE = new InjectionToken<IOptimizationService>('OptimizationService');
export const CHAT_SERVICE = new InjectionToken<IChatService>('ChatService');
export const TAB_MANAGER = new InjectionToken<ITabManager>('TabManager');
export const PROJECT_EXPORT_IMPORT_SERVICE = new InjectionToken<IProjectExportImportService>('ProjectExportImportService');
export const UPDATE_SERVICE = new InjectionToken<IUpdateService>('UpdateService');
export const BDF_SERVICE = new InjectionToken<BdfService>('BdfService');
export const SOFTJAWS_SERVICE = new InjectionToken<SoftjawsService>('SoftjawsService');
